import apolloClient from 'utils/apolloClient';
import PromotionalItemsQuery from 'assets/graphql/queries/PromoItems.graphql';

const promotionalItemsService = {
  getPromotionalItems: async () => {
    try {
      const { data } = await apolloClient.query({
        query: PromotionalItemsQuery,
      });
      return data?.promo_items;
    } catch (e) {
      throw new Error('Error fetching promotional items', e);
    }
  },
};

export default promotionalItemsService;
